import { IError } from '../store/types/common';

const isForbiddenError = ({ code }: IError) => (code === 403);

export default isForbiddenError;
